<template>
   <div id="form-one" class="form">
       <transition name="fade">
           <pop-tips :close="closePop" :popTipsValue="popTipsValue" v-if="popUpToggle"></pop-tips>
       </transition>
       <fieldset>
           <legend>您的基本資料</legend>
           <div class="half-line left">
               <input type="text" placeholder="中文姓氏" v-validate="{ required: true, regex:/^[\u4e00-\u9fa5]+$/, max: 17, min: 1 }" name="Client[client_last_name_ch]" data-vv-as="中文姓氏" v-model="client_last_name_ch">
               <span :class="{'invalid': errors.has('signup_agent_form.Client[client_last_name_ch]'), 'valid': !errors.has('signup_agent_form.Client[client_last_name_ch]')}">{{errors.first('signup_agent_form.Client[client_last_name_ch]')}}<span v-if="(!errors.has('signup_agent_form.Client[client_last_name_ch]') && client_last_name_ch.length > 0)">中文姓氏</span></span>
           </div>
           <div class="half-line right">
               <input type="text" placeholder="中文名字" v-validate="{required: true, regex: /^[\u4e00-\u9fa5]+$/, max: 20, min: 1}" name="Client[client_first_name_ch]" data-vv-as="中文名字" v-model="client_first_name_ch">
               <span :class="{'invalid': errors.has('signup_agent_form.Client[client_first_name_ch]'), 'valid': !errors.has('signup_agent_form.Client[client_first_name_ch]')}">{{errors.first('signup_agent_form.Client[client_first_name_ch]')}}<span v-if="(!errors.has('signup_agent_form.Client[client_first_name_ch]') && client_first_name_ch.length > 0)">中文名字</span></span>
           </div>
           <div class="half-line left">
               <input type="text" placeholder="英文姓氏" v-validate="{required: true, alpha_spaces: true, min: 2, max: 30}" name="Client[client_last_name_en]" data-vv-as="英文姓氏" v-model="client_last_name_en">
               <span :class="{'invalid': errors.has('signup_agent_form.Client[client_last_name_en]'), 'valid': !errors.has('signup_agent_form.Client[client_last_name_en]')}">{{errors.first('signup_agent_form.Client[client_last_name_en]')}}<span v-if="(!errors.has('signup_agent_form.Client[client_last_name_en]') && client_last_name_en.length > 0)">英文姓氏</span></span>
           </div>
           <div class="half-line right">
               <input type="text" placeholder="英文名字" v-validate="{required: true, regex: /^[a-zA-Z .]+$/, min: 2, max: 80}" name="Client[client_first_name_en]" data-vv-as="英文名字" v-model="client_first_name_en">
               <span :class="{'invalid': errors.has('signup_agent_form.Client[client_first_name_en]'), 'valid': !errors.has('signup_agent_form.Client[client_first_name_en]')}">{{errors.first('signup_agent_form.Client[client_first_name_en]')}}<span v-if="(!errors.has('signup_agent_form.Client[client_first_name_en]') && client_first_name_en.length > 0)">英文名字</span></span>
           </div>
           <div class="half-line left">
               <span v-if="client_title == ''">性別</span>
               <input type="radio" value="MR" name="Client[client_title]" id="gender-mr" v-validate="{gender: true, required: true}" v-model="client_title" data-vv-as="性別">
               <label for="gender-mr" class="label-after-break">先生♂️</label>
               <input type="radio" value="MS" name="Client[client_title]" id="gender-ms" v-model="client_title">
               <label for="gender-ms">女士♀️</label>
               <span :class="{'invalid': errors.has('signup_agent_form.Client[client_title]'), 'valid': !errors.has('signup_agent_form.Client[client_title]')}">{{errors.first('signup_agent_form.Client[client_title]')}}<span v-if="(!errors.has('signup_agent_form.Client[client_title]') && client_title.length > 0)">性別</span></span>
           </div>
           <div class="half-line right">
                <datepicker :miniumView="'day'" :maxiumView="'year'" :initialView="'year'" :language="datepicker_langs.zh" :disabledDates="{from: adultAgeLimit}" :open-date="adultAgeLimit" :format="'dd / MM / yyyy'" placeholder="出生日期" v-model="client_dob" @selected="clientDobSelectedOutput"></datepicker>
                <input type="text" name="Client[client_dob]" v-model="client_dob_formatted" v-validate="{required: true}" data-vv-as="出生日期" v-show>
               <span :class="{'invalid': errors.has('signup_agent_form.Client[client_dob]'), 'valid': !errors.has('signup_agent_form.Client[client_dob]')}">{{errors.first('signup_agent_form.Client[client_dob]')}}<span v-if="(!errors.has('signup_agent_form.Client[client_dob]') && client_dob_formatted.length > 0)">出生日期</span></span>
           </div>
       </fieldset>
       <fieldset>
           <legend>您的身份證明</legend>
           <div class="half-line left">
               <input type="text" placeholder="國籍" v-model="nationalitySearch" @keyup="searchNationality(); setDisplayNationality();" class="input-list-triggle">
               <input type="text" v-validate="{ required: true, nationality: true}" name="Client[client_nationality]" data-vv-as="國籍" v-model="client_nationality_formatted" v-show>
               <div class="dropdown-list-container">
                   <div class="dropdown-list" v-for="country in filteredNationality" @click="selectedNationality(country.displayName, country.value)">
                       <span>{{country.displayName}}</span>
                   </div>
               </div>
               <span :class="{'invalid': errors.has('signup_agent_form.Client[client_nationality]'), 'valid': !errors.has('signup_agent_form.Client[client_nationality]')}">{{errors.first('signup_agent_form.Client[client_nationality]')}}<span v-if="(!errors.has('signup_agent_form.Client[client_nationality]') && client_nationality.length > 0)">國籍</span></span>
           </div>
           <div class="half-line right">
               <div tabindex="0" class="input-list-triggle label-after-break" style="padding-right: 20px">{{client_gov_id_type}}<span v-if="client_gov_id_type == ''">證件類別</span><input type="text" v-validate="{required_choose: true, required: true}" name="Client[client_gov_id_type]" v-model="client_gov_id_type_formatted" data-vv-as="證件類別" v-show></div>
               <div class="dropdown-list-container">
                   <div class="dropdown-list" v-for="id in idType" @click="selectedIdType(id.displayName, id.value)">
                       <span>{{id.displayName}}</span>
                   </div>
               </div>
               <input type="text" v-validate="{required: true, min: 5, max: 50, regex: /^[A-Za-z0-9()-]+$/}" name="Client[client_gov_id_number]" v-model="client_gov_id_number" placeholder="證件號碼" data-vv-as="證件號碼" style="padding-left: 10px;">
               <span :class="{'invalid': (errors.has('signup_agent_form.Client[client_gov_id_type]') || errors.has('signup_agent_form.Client[client_gov_id_number]')), 'valid': (!errors.has('signup_agent_form.Client[client_gov_id_type]') && !errors.has('signup_agent_form.Client[client_gov_id_number]'))}">
               <span>{{errors.first('signup_agent_form.Client[client_gov_id_type]')}}</span>
               <span v-if="!errors.has('signup_agent_form.Client[client_gov_id_type]')">{{errors.first('signup_agent_form.Client[client_gov_id_number]')}}</span>
               <span v-if="(!errors.has('signup_agent_form.Client[client_gov_id_type]') && !errors.has('signup_agent_form.Client[client_gov_id_number]') && client_gov_id_type.length > 0 && client_gov_id_number.length > 0)">有效證件號碼</span>
               </span>
           </div>
           <div class="one-line upload-row">
              <span style="white-space: normal">上傳證件複本（僅限JPG、GIF、PNG圖片，並不大於5MB）<br>註：必須在證件複本旁簽署核實，否則需重新提交開戶申請<span class="info-btn" @click="popTips(1)">i</span></span>
               <label class="upload label-before-break" :style="[client_file1 == '' ? {'backgroundImage': ''} : {'backgroundImage': 'url(' + client_file1 + ')'}]"><input type="file" v-validate="{upload: true, size: 5120, mimes: ['image/jpg', 'image/jpeg', 'image/gif', 'image/png'], image: true, ext: ['jpg', 'jpeg', 'gif', 'png'], required: true}" name="Client[file1]" @change="uploadFile1" data-vv-as="上傳證件複本" accept=".jpg,.jpeg,.png,.gif">
               </label>
               <span :class="{'invalid': errors.has('signup_agent_form.Client[file1]'), 'valid': !errors.has('signup_agent_form.Client[file1]')}">{{errors.first('signup_agent_form.Client[file1]')}}<span v-if="(!errors.has('signup_agent_form.Client[file1]') && client_file1.length > 0)">已成功上傳證件複本，請查看縮圖，如有問題可點擊縮圖重新上傳</span></span>
           </div>
       </fieldset>
       <fieldset>
           <legend>您的居住地資料</legend>
           <div class="left" :class="{'half-line': client_residence_formatted == 'China', 'one-line': client_residence_formatted !== 'China'}">
               <input type="text" placeholder="居住地/地區" v-model="residenceSearch" @keyup="searchResidence(); setDisplayResidence();" class="input-list-triggle">
               <input type="text" v-validate="{ required: true, nationality: true}" name="Client[client_residence]" data-vv-as="居住地/地區" v-model="client_residence_formatted" v-show>
               <div class="dropdown-list-container">
                   <div class="dropdown-list" v-for="country in filteredResidence" @click="selectedResidence(country.displayName, country.value)">
                       <span>{{country.displayName}}</span>
                   </div>
               </div>
               <span :class="{'invalid': errors.has('signup_agent_form.Client[client_residence]'), 'valid': !errors.has('signup_agent_form.Client[client_residence]')}">{{errors.first('signup_agent_form.Client[client_residence]')}}<span v-if="(!errors.has('signup_agent_form.Client[client_residence]') && client_residence.length > 0)">居住地/地區</span></span>
           </div>
           <div class="half-line right" v-if="client_residence_formatted == 'China'">
               <input type="text" placeholder="省份" v-model="provinceSearch" @keyup="searchProvince(); setDisplayProvince();" class="input-list-triggle">
               <input type="text" v-validate="{ required: client_residence_formatted == 'China' ? true : false, china_province: true}" name="Client[client_province]" data-vv-as="省份" v-model="client_province_formatted" v-show>
               <div class="dropdown-list-container">
                   <div class="dropdown-list" v-for="country in filteredProvince" @click="selectedProvince(country.displayName, country.value)">
                       <span>{{country.displayName}}</span>
                   </div>
               </div>
               <span :class="{'invalid': errors.has('signup_agent_form.Client[client_province]'), 'valid': !errors.has('signup_agent_form.Client[client_province]')}">{{errors.first('signup_agent_form.Client[client_province]')}}<span v-if="(!errors.has('signup_agent_form.Client[client_province]') && client_province.length > 0)">省份</span></span>
           </div>
           <div class="one-line">
               <input type="text" placeholder="住宅地址" v-validate="{ required: true, max: 255, min: 6 }" name="Client[client_address]" data-vv-as="住宅地址" v-model="client_address">
               <span :class="{'invalid': errors.has('signup_agent_form.Client[client_address]'), 'valid': !errors.has('signup_agent_form.Client[client_address]')}">{{errors.first('signup_agent_form.Client[client_address]')}}<span v-if="(!errors.has('signup_agent_form.Client[client_address]') && client_address.length > 0)">住宅地址</span></span>
           </div>
           <div class="one-line" v-if="client_residence_formatted == 'China'">
               <span style="white-space: normal">本人聲明證件上的地址為最近三個月的有效地址。</span>
               <input type="checkbox" id="checkbox-1" name="Client[client_address_state]" v-model="client_address_state">
               <label for="checkbox-1"></label>
           </div>
           <div class="one-line upload-row" v-if="(!client_address_state || client_residence_formatted !== 'China')">
              <span style="white-space: normal">上傳最近三個月的有效住址證明<br>（僅限JPG、GIF、PNG圖片，並不大於5MB）<span class="info-btn" @click="popTips(3)">i</span></span>
               <label class="upload label-before-break" :style="[client_file3 == '' ? {'backgroundImage': ''} : {'backgroundImage': 'url(' + client_file3 + ')'}]"><input type="file" v-validate="{upload: !client_address_state, size: 5120, mimes: ['image/jpg', 'image/jpeg', 'image/gif', 'image/png'], image: true, ext: ['jpg', 'jpeg', 'gif', 'png'], required: true}" name="Client[file3]" @change="uploadFile3" data-vv-as="上傳證件複本" accept=".jpg,.jpeg,.png,.gif">
               </label>
               <span :class="{'invalid': errors.has('signup_agent_form.Client[file3]'), 'valid': !errors.has('signup_agent_form.Client[file3]')}">{{errors.first('signup_agent_form.Client[file3]')}}<span v-if="(!errors.has('signup_agent_form.Client[file3]') && client_file3.length > 0)">已成功上傳證件複本，請查看縮圖，如有問題可點擊縮圖重新上傳</span></span>
           </div>
       </fieldset>
       <fieldset>
           <legend>國籍以外其他納稅人身份</legend>
           <div class="one-line">
               <span style="white-space: normal">本人聲明沒有國籍以外其他納稅人身份。</span>
               <input type="checkbox" id="checkbox-2" name="Client[client_other_taxpayer_status]" v-model="client_other_taxpayer_status">
               <label for="checkbox-2"></label>
           </div>
           <div class="one-line" v-if="!client_other_taxpayer_status">
               <span style="white-space: normal" class="add-drop-list-container">
                   <span>本人同時為</span>
                   <span>
                       <span v-for="(taxpayer, index) in client_other_taxpayers_list"><span @click="removeTaxpayerFromList(index, taxpayer.value, taxpayer.id)" class="remove-from-list-triggle">{{taxpayer.displayName}}</span></span>
                   </span>
                   <span>的納稅人身份。</span>
               </span>
               <input type="text" v-model="client_other_taxpayers_list_formatted" v-show v-validate="{required: true}" name="Client[client_other_taxpayers_list]" data-vv-as="增加地區" data-vv-name="client_other_taxpayers_list">
               <div tabindex="0" class="input-list-triggle add-to-list-triggle" style="padding-left: 10px; align-self: flex-end;">增加地區</div>
               <div class="dropdown-list-container">
                   <div class="dropdown-list" v-for="(taxpayer, index) in client_other_taxpayers_list_store" :key="taxpayer.value" @click="pushTaxpayerToList(index, taxpayer.value, taxpayer.id)" v-if="!taxpayer.checked">
                       <span>{{taxpayer.displayName}}</span>
                   </div>
               </div>
               <span :class="{'invalid': errors.has('signup_agent_form.client_other_taxpayers_list')}">{{errors.first('signup_agent_form.client_other_taxpayers_list')}}</span>
           </div>
       </fieldset>
       <fieldset>
           <legend>您的聯絡方式</legend>
           <div class="half-line left">
               <input type="text" placeholder="聯絡電話" v-validate="{required: true, phone: true}" name="Client[client_tel]" data-vv-as="聯絡電話" v-model="client_tel" @focus="formatPhone" @input="phoneOnInput">
               <span :class="{'invalid': errors.has('signup_agent_form.Client[client_tel]'), 'valid': !errors.has('signup_agent_form.Client[client_tel]')}">{{errors.first('signup_agent_form.Client[client_tel]')}}<span v-if="(!errors.has('signup_agent_form.Client[client_tel]') && client_tel.length > 0)">聯絡電話</span></span>
           </div>
           <div class="half-line right">
               <input type="text" placeholder="手機號碼" v-validate="{required: true, mobile: true}" name="Client[client_mob]" data-vv-as="手機號碼" v-model="client_mob" @focus="formatMobile" @input="mobileOnInput">
               <span :class="{'invalid': errors.has('signup_agent_form.Client[client_mob]'), 'valid': !errors.has('signup_agent_form.Client[client_mob]')}">{{errors.first('signup_agent_form.Client[client_mob]')}}<span v-if="(!errors.has('signup_agent_form.Client[client_mob]') && client_mob.length > 0)">手機號碼</span></span>
           </div>
           <div class="half-line left">
               <input type="text" placeholder="QQ號（選填）" v-validate="{ numeric: true, min: 5, max: 20}" name="Client[client_qq]" data-vv-as="QQ號" v-model="client_qq" @focus="formatPhone" @input="phoneOnInput">
               <span :class="{'invalid': errors.has('signup_agent_form.Client[client_qq]'), 'valid': !errors.has('signup_agent_form.Client[client_qq]')}">{{errors.first('signup_agent_form.Client[client_qq]')}}<span v-if="(!errors.has('signup_agent_form.Client[client_qq]') && client_qq.length > 0)">QQ號</span></span>
           </div>
           <div class="half-line right">
               <input type="text" placeholder="電郵" v-validate="{required: true, email: true}" name="Client[client_email]" data-vv-as="電郵" v-model="client_email">
               <span :class="{'invalid': errors.has('signup_agent_form.Client[client_email]'), 'valid': !errors.has('signup_agent_form.Client[client_email]')}">{{errors.first('signup_agent_form.Client[client_email]')}}<span v-if="(!errors.has('signup_agent_form.Client[client_email]') && client_email.length > 0)">電郵</span></span>
           </div>
       </fieldset>
   </div>
</template>

<script>
    import * as lang from "vuejs-datepicker/src/locale";
    import {formatNumber, isValidNumber, AsYouType, getNumberType} from "libphonenumber-js";
    import intPhoneCountries from "../assets/int-phone-countries.js";
    import intPhoneMetadata from "libphonenumber-js/metadata.full.json";
    import popTips from "./popTips.vue";
    export default {
        inherit: true,
        inject: ['$validator'],
        name: "formOne",
        components: {
            "pop-tips": popTips
        },
        data: () => ({
            /* pop Up Tips */
            popTipsValue: "",
            popUpToggle: false,
            /* vuejs-datepicker setting below */
            datepicker_lang: "zh",
            datepicker_langs: lang,
            /* int phone setting below */
            int_phone: {
                mode: "International",
                intPhoneCountries,
                activeFlag: "cn"
            },
            /* v-model below, form core */
            client_last_name_ch: "",
            client_first_name_ch: "",
            client_last_name_en: "",
            client_first_name_en: "",
            client_title: "",
            client_dob: "",
            client_dob_formatted: "",
            client_nationality: "",
            client_nationality_formatted: "",
            client_gov_id_type: "",
            client_gov_id_type_formatted: "",
            client_gov_id_number: "",
            client_file1: "",
//            client_file2: "",
            client_file3: "",
            client_residence: "",
            client_residence_formatted: "",
            client_province: "",
            client_province_formatted: "",
            client_address: "",
            client_address_state: true,
            client_other_taxpayer_status: true,
            client_other_taxpayers_list_store: null,
            client_other_taxpayers_list: [],
            client_other_taxpayers_list_formatted: [],
            client_tel: "",
            client_mob: "",
            client_qq: "",
            client_email: "",
            /* get sync time below */
            today: new Date(today()), //parse to js Date format
            adultAgeLimit: adultAgeLimit(),
            todayformatted: new Date(today()).toString(), //to string
            adultAgeLimitformatted: adultAgeLimit().toString(), //to string
            /* country list below */
            countries:[
                {order: "1", value: "China", displayName: "中國"},
                {order: "2", value: "Macau", displayName: "澳門"},
                {order: "3", value: "Afghanistan", displayName: "阿富汗"},
                {order: "4", value: "Albania", displayName: "阿爾巴尼亞"},
                {order: "5", value: "Algeria", displayName: "阿爾及利亞"},
                {order: "6", value: "Andorra", displayName: "安道爾"},
                {order: "7", value: "Angola", displayName: "安哥拉"},
                {order: "8", value: "Anguilla", displayName: "安圭拉"},
                {order: "9", value: "Antarctica", displayName: "南極洲"},
                {order: "10", value: "Antigua and Barbuda", displayName: "安提瓜和巴布達"},
                {order: "11", value: "Argentina", displayName: "阿根廷"},
                {order: "12", value: "Armenia", displayName: "亞美尼亞"},
                {order: "14", value: "Aruba", displayName: "阿魯巴"},
                {order: "15", value: "Australia", displayName: "澳大利亞"},
                {order: "16", value: "Austria", displayName: "奧地利"},
                {order: "17", value: "Azerbaijan", displayName: "阿塞拜疆"},
                {order: "18", value: "Bahamas", displayName: "巴哈馬"},
                {order: "19", value: "Bahrain", displayName: "巴林"},
                {order: "20", value: "Bangladesh", displayName: "孟加拉國"},
                {order: "21", value: "Barbados", displayName: "巴巴多斯"},
                {order: "22", value: "Belarus", displayName: "白俄羅斯"},
                {order: "23", value: "Belgium", displayName: "比利時"},
                {order: "24", value: "Belize", displayName: "伯利茲"},
                {order: "25", value: "Benin", displayName: "貝寧"},
                {order: "26", value: "Bermuda", displayName: "百慕大"},
                {order: "27", value: "Bhutan", displayName: "不丹"},
                {order: "28", value: "Bolivia", displayName: "玻利維亞"},
                {order: "30", value: "Bosnia and Herzegovina", displayName: "波斯尼亞和黑塞哥維那"},
                {order: "31", value: "Botswana", displayName: "博茨瓦納"},
                {order: "32", value: "Bouvet Island", displayName: "布維島"},
                {order: "33", value: "Brazil", displayName: "巴西"},
                {order: "34", value: "British indian Ocean Territory", displayName: "英屬印度洋領土"},
                {order: "35", value: "British Virgin Islands", displayName: "英屬維爾京群島"},
                {order: "36", value: "Brunei Darussalam", displayName: "文萊"},
                {order: "37", value: "Bulgaria", displayName: "保加利亞"},
                {order: "38", value: "Burkina Faso", displayName: "布基納法索"},
                {order: "39", value: "Burundi", displayName: "布隆迪"},
                {order: "40", value: "Cambodia", displayName: "柬埔寨"},
                {order: "41", value: "Cameroon", displayName: "喀麥隆"},
                {order: "42", value: "Canada", displayName: "加拿大"},
                {order: "43", value: "Cape Verde", displayName: "佛得角"},
                {order: "44", value: "Cayman Islands", displayName: "開曼群島"},
                {order: "45", value: "Central Africa", displayName: "中非"},
                {order: "46", value: "Chad", displayName: "乍得"},
                {order: "47", value: "Chile", displayName: "智利"},
                {order: "48", value: "Christmas Island", displayName: "聖誕島"},
                {order: "49", value: "Cocos(Keeling) Islands", displayName: "科科斯(基林)群島"},
                {order: "50", value: "Colombia", displayName: "哥倫比亞"},
                {order: "51", value: "Comoros", displayName: "科摩羅"},
                {order: "52", value: "Congo", displayName: "剛果"},
                {order: "53", value: "Cook Islands", displayName: "庫克群島"},
                {order: "54", value: "Costa Rica", displayName: "哥斯達黎加"},
                {order: "55", value: "Cote d Ivoire", displayName: "科特迪瓦"},
                {order: "56", value: "Croatia", displayName: "克羅地亞"},
                {order: "57", value: "Cuba", displayName: "古巴"},
                {order: "58", value: "Cyprus", displayName: "塞浦路斯"},
                {order: "59", value: "Czech Repoublic", displayName: "捷克"},
                {order: "60", value: "Denmark", displayName: "丹麥"},
                {order: "61", value: "Djibouti", displayName: "吉布提"},
                {order: "62", value: "Dominica", displayName: "多米尼克"},
                {order: "63", value: "Dominican Republic", displayName: "多米尼加共和國"},
                {order: "64", value: "East Timor", displayName: "東帝汶"},
                {order: "65", value: "Ecuador", displayName: "厄瓜多爾"},
                {order: "66", value: "Egypt", displayName: "埃及"},
                {order: "67", value: "El Salvador", displayName: "薩爾瓦多"},
                {order: "68", value: "Equatorial Guinea", displayName: "赤道幾內亞"},
                {order: "69", value: "Eritrea", displayName: "厄立特里亞"},
                {order: "70", value: "Estonia", displayName: "愛沙尼亞"},
                {order: "71", value: "Ethiopia", displayName: "埃塞俄比亞"},
                {order: "72", value: "Faroe Islands", displayName: "法羅群島"},
                {order: "73", value: "Fiji", displayName: "斐濟"},
                {order: "74", value: "Finland", displayName: "芬蘭"},
                {order: "75", value: "France", displayName: "法國"},
                {order: "76", value: "French Guiana", displayName: "法屬圭亞那"},
                {order: "77", value: "French Polynesia", displayName: "法屬波利尼西亞"},
                {order: "78", value: "French Southern Territories", displayName: "法屬南部領土"},
                {order: "79", value: "Gabon", displayName: "加蓬"},
                {order: "80", value: "Gambia", displayName: "岡比亞"},
                {order: "81", value: "Georgia", displayName: "格魯吉亞"},
                {order: "82", value: "Germany", displayName: "德國"},
                {order: "83", value: "Ghana", displayName: "加納"},
                {order: "84", value: "Gibraltar", displayName: "直布羅陀"},
                {order: "85", value: "Greece", displayName: "希臘"},
                {order: "86", value: "Greenland", displayName: "格陵蘭"},
                {order: "87", value: "Grenada", displayName: "格林納達"},
                {order: "88", value: "Guadeloupe", displayName: "瓜德羅普"},
                {order: "89", value: "Guam", displayName: "關島"},
                {order: "90", value: "Guatemala", displayName: "危地馬拉"},
                {order: "91", value: "Guinea", displayName: "幾內亞"},
                {order: "92", value: "Guine-bissau", displayName: "幾內亞比紹"},
                {order: "93", value: "Guyana", displayName: "圭亞那"},
                {order: "94", value: "Haiti", displayName: "海地"},
                {order: "95", value: "Heard islands and Mc Donald Islands", displayName: "赫德島和麥克唐納島"},
                {order: "96", value: "Honduras", displayName: "洪都拉斯"},
                {order: "97", value: "Hungary", displayName: "匈牙利"},
                {order: "98", value: "Iceland", displayName: "冰島"},
                {order: "99", value: "India", displayName: "印度"},
                {order: "100", value: "Indonesia", displayName: "印度尼西亞"},
                {order: "101", value: "Iran", displayName: "伊朗"},
                {order: "102", value: "Iraq", displayName: "伊拉克"},
                {order: "103", value: "Ireland", displayName: "愛爾蘭"},
                {order: "104", value: "Israel", displayName: "以色列"},
                {order: "105", value: "Italy", displayName: "意大利"},
                {order: "106", value: "Jamaica", displayName: "牙買加"},
                {order: "107", value: "Japan", displayName: "日本"},
                {order: "108", value: "Jordan", displayName: "約旦"},
                {order: "109", value: "Kazakhstan", displayName: "哈隆克斯坦"},
                {order: "110", value: "Kenya", displayName: "肯尼亞"},
                {order: "111", value: "Kiribati", displayName: "基里巴斯"},
                {order: "112", value: "Korea,Democratic Peoples Republic of", displayName: "朝鮮"},
                {order: "113", value: "Korea,Republic of", displayName: "韓國"},
                {order: "114", value: "Kuwait", displayName: "科威特"},
                {order: "115", value: "Kyrgyzstan", displayName: "吉爾吉斯斯坦"},
                {order: "116", value: "Lao", displayName: "老撾"},
                {order: "117", value: "Latvia", displayName: "拉脫維亞"},
                {order: "118", value: "Lebanon", displayName: "黎巴嫩"},
                {order: "119", value: "Lesotho", displayName: "萊索托"},
                {order: "120", value: "Liberia", displayName: "利比里亞"},
                {order: "121", value: "Libya", displayName: "利比亞"},
                {order: "122", value: "Liechtenstein", displayName: "列支敦士登"},
                {order: "123", value: "Lithuania", displayName: "立陶宛"},
                {order: "124", value: "Luxembourg", displayName: "盧森堡"},
                {order: "125", value: "Macedonia", displayName: "馬斯頓"},
                {order: "126", value: "Madagascar", displayName: "馬達加斯加"},
                {order: "127", value: "Malawi", displayName: "馬拉維"},
                {order: "128", value: "Malaysia", displayName: "馬來西亞"},
                {order: "129", value: "Maldives", displayName: "馬爾代夫"},
                {order: "130", value: "Mali", displayName: "馬里"},
                {order: "131", value: "Malta", displayName: "馬耳他"},
                {order: "132", value: "Malvinas Islands (Falkland Islands)", displayName: "馬爾維納斯群島(福克蘭群島)"},
                {order: "133", value: "Marshall Islands", displayName: "馬紹爾群島"},
                {order: "134", value: "Martinique", displayName: "馬提尼克"},
                {order: "135", value: "Mauritania", displayName: "毛里塔尼亞"},
                {order: "136", value: "Mauritius", displayName: "毛里求斯"},
                {order: "137", value: "Mayotte", displayName: "馬約特"},
                {order: "138", value: "Mexico", displayName: "墨西哥"},
                {order: "139", value: "Micronesia", displayName: "密克羅尼西亞"},
                {order: "140", value: "Moldova", displayName: "摩爾多瓦"},
                {order: "141", value: "Monaco", displayName: "摩納哥"},
                {order: "142", value: "Mongolia", displayName: "蒙古"},
                {order: "143", value: "Montserrat", displayName: "蒙特塞拉特"},
                {order: "144", value: "Morocco", displayName: "摩洛哥"},
                {order: "145", value: "Mozambique", displayName: "莫桑比亞"},
                {order: "146", value: "Myanmar", displayName: "緬甸"},
                {order: "147", value: "Namibia", displayName: "納米比亞"},
                {order: "148", value: "Nauru", displayName: "瑙魯"},
                {order: "149", value: "Nepal", displayName: "尼泊爾"},
                {order: "150", value: "Netherlands", displayName: "荷蘭"},
                {order: "151", value: "Netherlands Antilles", displayName: "荷屬安的列斯"},
                {order: "152", value: "New Caledonia", displayName: "新喀里多尼亞"},
                {order: "153", value: "New Zealand", displayName: "新西蘭"},
                {order: "154", value: "Nicaragua", displayName: "尼加拉瓜"},
                {order: "155", value: "Niger", displayName: "尼日爾"},
                {order: "156", value: "Nigeria", displayName: "尼日利亞"},
                {order: "157", value: "Niue", displayName: "紐埃"},
                {order: "158", value: "Norfolk Island", displayName: "諾福克島"},
                {order: "159", value: "Northern Marianas", displayName: "北馬里亞納"},
                {order: "160", value: "Norway", displayName: "挪威"},
                {order: "161", value: "Oman", displayName: "阿曼"},
                {order: "162", value: "Pakistan", displayName: "巴基斯坦"},
                {order: "163", value: "Palau", displayName: "貝勞"},
                {order: "164", value: "Palestine", displayName: "巴勒斯坦"},
                {order: "165", value: "Panama", displayName: "巴拿馬"},
                {order: "166", value: "Papua New Guinea", displayName: "巴布亞新幾內亞"},
                {order: "167", value: "Paraguay", displayName: "巴拉圭"},
                {order: "168", value: "Peru", displayName: "秘魯"},
                {order: "169", value: "Philippines", displayName: "菲律賓"},
                {order: "170", value: "Pitcairn Islands Group", displayName: "皮特凱恩島"},
                {order: "171", value: "Poland", displayName: "波蘭"},
                {order: "172", value: "Portugal", displayName: "葡萄牙"},
                {order: "173", value: "Puerto Rico", displayName: "波多黎各"},
                {order: "174", value: "Qatar", displayName: "卡塔爾"},
                {order: "175", value: "Reunion", displayName: "留尼汪"},
                {order: "176", value: "Romania", displayName: "羅馬尼亞"},
                {order: "177", value: "Russia", displayName: "俄羅斯"},
                {order: "178", value: "Rwanda", displayName: "盧旺達"},
                {order: "179", value: "Saint helena", displayName: "聖赫勒拿"},
                {order: "180", value: "Saint Kitts and nevis", displayName: "聖基茨和尼維斯"},
                {order: "181", value: "Saint lucia", displayName: "聖盧西亞"},
                {order: "182", value: "Saint Pierre and Miquelon", displayName: "聖皮埃爾和密克隆"},
                {order: "183", value: "Saint Vincent and the Grenadines", displayName: "聖文森特和格林納丁斯"},
                {order: "184", value: "San Marion", displayName: "聖馬力諾"},
                {order: "185", value: "Sao Tome and Principe", displayName: "聖多美和普林西比"},
                {order: "186", value: "Saudi Arabia", displayName: "沙竺阿拉伯"},
                {order: "187", value: "Senegal", displayName: "塞內加爾"},
                {order: "188", value: "Seychells", displayName: "塞舌爾"},
                {order: "189", value: "Sierra leone", displayName: "塞拉利昂"},
                {order: "190", value: "Singapore", displayName: "新加坡"},
                {order: "191", value: "Slovakia", displayName: "斯洛伐克"},
                {order: "192", value: "Slovenia", displayName: "斯洛文尼亞"},
                {order: "193", value: "Solomon Islands", displayName: "所羅門群島"},
                {order: "194", value: "Somalia", displayName: "索馬里"},
                {order: "195", value: "South Africa", displayName: "南非"},
                {order: "196", value: "South Georgia and South Sandwich Islands", displayName: "南喬治亞島和南桑德韋奇島"},
                {order: "197", value: "Spain", displayName: "西班牙"},
                {order: "198", value: "Sri Lanka", displayName: "斯里蘭卡"},
                {order: "199", value: "Sudan", displayName: "蘇丹"},
                {order: "200", value: "Suriname", displayName: "蘇里南"},
                {order: "201", value: "Svalbard and jan Mayen Islands", displayName: "斯瓦爾巴群島"},
                {order: "202", value: "Swaziland", displayName: "斯威士蘭"},
                {order: "203", value: "Sweden", displayName: "瑞典"},
                {order: "204", value: "Switzerland", displayName: "瑞士"},
                {order: "205", value: "Syria", displayName: "敘利亞"},
                {order: "206", value: "Tajikistan", displayName: "塔吉克斯坦"},
                {order: "207", value: "Tanzania", displayName: "坦桑尼亞"},
                {order: "208", value: "Thailand", displayName: "泰國"},
                {order: "209", value: "Togo", displayName: "多哥"},
                {order: "210", value: "Tokelau", displayName: "托克勞"},
                {order: "211", value: "Tonga", displayName: "湯加"},
                {order: "212", value: "Trinidad and Tobago", displayName: "特立尼達和多巴哥"},
                {order: "213", value: "Tunisia", displayName: "突尼斯"},
                {order: "214", value: "Turkey", displayName: "土耳其"},
                {order: "215", value: "Turkmenistan", displayName: "土庫曼斯坦"},
                {order: "216", value: "Turks and Caicos Islands", displayName: "特克斯科斯群島"},
                {order: "217", value: "Tuvalu", displayName: "圖瓦盧"},
                {order: "218", value: "Uganda", displayName: "烏乾達"},
                {order: "219", value: "Ukraine", displayName: "烏克蘭"},
                {order: "220", value: "United Arab Emirates", displayName: "阿聯酋"},
                {order: "221", value: "United Kingdom", displayName: "英國"},
                {order: "222", value: "United States", displayName: "美國"},
                {order: "223", value: "Uruguay", displayName: "烏拉圭"},
                {order: "224", value: "Uzbekistan", displayName: "烏茲別克斯坦"},
                {order: "225", value: "Vanuatu", displayName: "瓦努阿圖"},
                {order: "226", value: "Vatican", displayName: "梵蒂岡"},
                {order: "227", value: "Venezuela", displayName: "委內瑞拉"},
                {order: "228", value: "Viet Nam", displayName: "越南"},
                {order: "229", value: "Wallis and Futuna Is-lands", displayName: "瓦利斯和富圖納群島"},
                {order: "230", value: "Western Sahara", displayName: "西撒哈拉"},
                {order: "231", value: "Western Samoa", displayName: "西薩摩亞"},
                {order: "232", value: "Yemen", displayName: "也門"},
                {order: "233", value: "Yugoslavia", displayName: "南斯拉夫"},
                {order: "234", value: "Zaire", displayName: "扎伊爾"},
                {order: "235", value: "Zambia", displayName: "贊比亞"},
                {order: "236", value: "Zimbabwe", displayName: "津巴布韋"}
            ],
            /* nationality search model (v-model)*/
            nationalitySearch: "",
            /* residence search model (v-model) */
            residenceSearch: "",
            /* China province list below */
            chinaProvinces:[
                {order: "1", value: "ANHUI", displayName: "安徽"},
                {order: "2", value: "BEIJING", displayName: "北京"},
                {order: "3", value: "CHONGQING", displayName: "重慶"},
                {order: "4", value: "FUJIAN", displayName: "福建"},
                {order: "5", value: "GANSU", displayName: "甘肅"},
                {order: "6", value: "GUANGDONG", displayName: "廣東"},
                {order: "7", value: "GUANGXI", displayName: "廣西自治區"},
                {order: "8", value: "GUIZHOU", displayName: "貴州"},
                {order: "9", value: "HAINAN", displayName: "海南"},
                {order: "10", value: "HEBEI", displayName: "河北"},
                {order: "11", value: "HEILONGJIANG", displayName: "黑龍江"},
                {order: "12", value: "HENAN", displayName: "河南"},
                {order: "13", value: "HUBEI", displayName: "湖北"},
                {order: "14", value: "HUNAN", displayName: "湖南"},
                {order: "15", value: "INNER MONGOLIA", displayName: "內蒙古自治區"},
                {order: "16", value: "JIANGSU", displayName: "江蘇"},
                {order: "17", value: "JIANGXI", displayName: "江西"},
                {order: "18", value: "JILIN", displayName: "吉林"},
                {order: "19", value: "LIAONING", displayName: "遼寧"},
                {order: "20", value: "NINGXIA", displayName: "寧夏自治區"},
                {order: "21", value: "QINGHAI", displayName: "青海"},
                {order: "22", value: "SHAANXI", displayName: "陝西"},
                {order: "23", value: "SHANDONG", displayName: "山東"},
                {order: "24", value: "SHANGHAI", displayName: "上海"},
                {order: "25", value: "SHANXI", displayName: "山西"},
                {order: "26", value: "SICHUAN", displayName: "四川"},
                {order: "27", value: "TAIWAN", displayName: "台灣"},
                {order: "28", value: "TIANJIN", displayName: "天津"},
                {order: "29", value: "TIBET", displayName: "西藏自治區"},
                {order: "30", value: "XINJIANG", displayName: "新疆自治區"},
                {order: "31", value: "YUNNAN", displayName: "雲南"},
                {order: "32", value: "ZHEJIANG", displayName: "浙江"},
                {order: "33", value: "Others", displayName: "其他/不在此列表"},
            ],
            /* China province search model (v-model) */
            provinceSearch: "",
            /* id type list below */
            idType: [
                {order: "1", value: "ID", displayName: "身份證"},
                {order: "2", value: "Passport", displayName: "護照"}
            ],
        }),
        methods: {
            popTips(tipsType){
                this.popTipsValue = tipsType;
                this.popUpToggle = !this.popUpToggle;
            },
            closePop(){
                this.popUpToggle = false;
            },
            clientDobSelectedOutput(output){
//                let outputToString = ("0" + output.getDate()).slice(-2) + "/" + ("0" + (output.getMonth() + 1)).slice(-2) + "/" + output.getFullYear(); /* return as user view */
                let outputToString = output.getFullYear() + "-" + ("0" + (output.getMonth() + 1)).slice(-2) + "-" + ("0" + output.getDate()).slice(-2);
                this.client_dob_formatted = outputToString.toString();
            },
            selectedNationality(displayName, value){
                this.nationalitySearch = displayName;
                this.client_nationality = displayName;
                this.client_nationality_formatted = value;
            },
            searchNationality(){
                let searchVal = this.nationalitySearch;
                let countriesList = this.countries;
                this.client_nationality_formatted = searchVal;
                for (var i = 0; i < countriesList.length; i++){
                    if(countriesList[i].displayName == searchVal){
                        this.client_nationality_formatted = countriesList[i].value;
                    }
                }
            },
            setDisplayNationality(){
                this.client_nationality = this.nationalitySearch;
            },
            selectedIdType(displayName, value){
                this.client_gov_id_type = displayName;
                this.client_gov_id_type_formatted = value;
            },
            uploadFile1(e){
                var files = e.target.files || e.dataTransfer.files;
                var self = this;
                setTimeout(function(){
                    if(!self.$validator.errors.has('signup_agent_form.Client[file1]')){
                        if(!files.length)
                            return;
                        self.createImageFile1(files[0]);
                        self.client_file1 = files[0];
                    }else if(self.$validator.errors.has('signup_agent_form.Client[file1]')){
                        self.client_file1 = "";
                    }
                }, 500);
            },
            createImageFile1(file){
                const render = new FileReader();
                render.onload = (e) => {
                    this.client_file1 = e.target.result;
                };
                render.readAsDataURL(file);
            },
            uploadFile3(e){
                var files = e.target.files || e.dataTransfer.files;
                var self = this;
                setTimeout(function(){
                    if(!self.$validator.errors.has('signup_agent_form.Client[file3]')){
                        if(!files.length)
                            return;
                        self.createImageFile3(files[0]);
                        self.client_file3 = files[0];
                    }else if(self.$validator.errors.has('signup_agent_form.Client[file3]')){
                        self.client_file3 = "";
                    }
                }, 500);
            },
            createImageFile3(file){
                const render = new FileReader();
                render.onload = (e) => {
                    this.client_file3 = e.target.result;
                };
                render.readAsDataURL(file);
            },
            selectedResidence(displayName, value){
                this.residenceSearch = displayName;
                this.client_residence = displayName;
                this.client_residence_formatted = value;
            },
            searchResidence(){
                let searchVal = this.residenceSearch;
                let countriesList = this.countries;
                this.client_residence_formatted = searchVal;
                for (var i = 0; i < countriesList.length; i++){
                    if(countriesList[i].displayName == searchVal){
                        this.client_residence_formatted = countriesList[i].value;
                    }
                }
            },
            setDisplayResidence(){
                this.client_residence = this.residenceSearch;
            },
            selectedProvince(displayName, value){
                this.provinceSearch = displayName;
                this.client_province = displayName;
                this.client_province_formatted = value;
            },
            searchProvince(){
                let searchVal = this.provinceSearch;
                let provinceList = this.chinaProvinces;
                this.client_province_formatted = searchVal;
                for (var i = 0; i < provinceList.length; i++){
                    if(provinceList[i].displayName == searchVal){
                        this.client_province_formatted = provinceList[i].value;
                    }
                }
            },
            setDisplayProvince(){
                this.client_province = this.provinceSearch;
            },
            pushTaxpayerToList(index, value, id){
                this.client_other_taxpayers_list.push(this.client_other_taxpayers_list_store[index]);
                this.client_other_taxpayers_list_formatted.push(value);
                this.client_other_taxpayers_list_store[index].checked = !this.client_other_taxpayers_list_store[index].checked;
            },
            removeTaxpayerFromList(index, value, id){
                var self = this;
                this.client_other_taxpayers_list.splice(index, 1);
                this.client_other_taxpayers_list_formatted.forEach(function(item, index){
                   if(item == value){
                       self.client_other_taxpayers_list_formatted.splice(index, 1);
                   }
                });
                for(var i = 0; i < this.client_other_taxpayers_list_store.length; i++){
                    if(self.client_other_taxpayers_list_store[i].id == id){
                        self.client_other_taxpayers_list_store[i].checked = !self.client_other_taxpayers_list_store[i].checked;
                    }
                }
            },
            phoneOnInput(){
                const codeStart = this.client_tel.indexOf("+");
                this.client_tel = this.client_tel.substr(codeStart);
                this.formatPhone();
//                if(this.intPhoneMeta.country){
//                    this.int_phone.activeFlag = this.intPhoneMeta.
//                }
            },
            formatPhone(){
                this.client_tel = formatNumber(this.client_tel || this.defaultPhoneValue, "", this.int_phone.mode);
            },
            mobileOnInput(){
                const codeStart = this.client_mob.indexOf("+");
                this.client_mob = this.client_mob.substr(codeStart);
                this.formatMobile();
            },
            formatMobile(){
                this.client_mob = formatNumber(this.client_mob || this.defaultMobileValue, "", this.int_phone.mode);
            },
        },
        computed: {
            filteredNationality(){
                var self = this;
                return this.countries.filter(function(list){
                    return list.displayName.indexOf(self.nationalitySearch) >= 0;
                });
            },
            filteredResidence(){
                var self = this;
                return this.countries.filter(function(list){
                    return list.displayName.indexOf(self.residenceSearch) >= 0;
                });
            },
            filteredProvince(){
                var self = this;
                return this.chinaProvinces.filter(function(list){
                    return list.displayName.indexOf(self.provinceSearch) >= 0;
                });
            },
//            intPhoneMeta(){
//                const asYouType = new AsYouType();
//                asYouType.input(this.client_tel);
//                return asYouType;
//            },
            defaultPhoneValue(){
                const [, , dial] = this.int_phone.intPhoneCountries.find(el => el[1] === this.int_phone.activeFlag);
                return `+${dial}`;
            },
//            intMobileMeta(){
//                const asYouType = new AsYouType();
//                asYouType.input(this.client_mob);
//                return asYouType;
//            },
            defaultMobileValue(){
                const [, , dial] = this.int_phone.intPhoneCountries.find(el => el[1] === this.int_phone.activeFlag);
                return `+${dial}`;
            }
        },
        beforeMount: function(){
            this.client_other_taxpayers_list_store = this.countries;
            for(var i = 0; i < this.client_other_taxpayers_list_store.length; i++){
                this.$set(this.client_other_taxpayers_list_store[i], "checked", false);
                this.$set(this.client_other_taxpayers_list_store[i], "id", i.toString());
                this.$delete(this.client_other_taxpayers_list_store[i], "order");
            }
        },
        created: function(){
//            this.$validator.extend("phone", {
//                getMessage: (field) => "請填寫有效" + field,
//                validate: (input, args) =>{
//                    return isValidNumber(input, intPhoneMetadata);
//                }
//            });
//            this.$validator.extend("mobile", {
//                getMessage: (field) => "請填寫有效" + field,
//                validate: (input, args) =>{
//                    if(getNumberType(input, intPhoneMetadata) === "MOBILE"){
//                        return isValidNumber(input, intPhoneMetadata);
//                    }else{
//                        return false;
//                    }
//                }
//            });
            this.$validator.localize({
                zh_TW:{
                    custom:{
                        client_other_taxpayers_list:{
                            required: "請最少增加一個地區"
                        }
                    }
                }
            });
        }
    };

    /* get server time */
    var today = function(){
        try {
            xmlHttpRequest = new XMLHttpRequest();
//            console.log("get today no err");
        } catch (err1) {
            try {
                xmlHttpRequest = new ActiveXObject('Msxml2.XMLHTTP');
//                console.log("get today err1");
            } catch (err2) {
                try {
                    xmlHttpRequest = new ActiveXObject('Microsoft.XMLHTTP');
//                    console.log("get today err2");
                } catch (err3) {
                    //not support, return client side date
                   return new Date();
//                    console.log("get today err3, retured client side new Date()");
                }
            }
        }
        xmlHttpRequest.open('HEAD', window.location.href.toString(), false);
        xmlHttpRequest.setRequestHeader("Content-Type", "text/html");
        xmlHttpRequest.send(' ');
        return xmlHttpRequest.getResponseHeader("Date");
//        console.log("get today returned");
    }
    var adultAgeLimit = function(){
        var now = new Date(today());
        var _18YearsAgo = new Date(today());
        _18YearsAgo.setDate(now.getDate());
        _18YearsAgo.setMonth(now.getMonth());
        _18YearsAgo.setFullYear(now.getFullYear() - 18);
        return new Date(_18YearsAgo);
    }
</script>



<style scoped lang="scss">
</style>
